/**
 * The customer-support mailbox — the single source. Inside translated copy it goes in as a
 * `{{param}}`, never written into the translation string: an address buried in a translation
 * is invisible to a code search and silently goes stale.
 */
export const SUPPORT_EMAIL = 'support@mobeyond.eu';

/**
 * The support site — the "Support Center" link's destination.
 *
 * Domain only: each reader appends the language and page path, which are runtime values.
 * Support content exists in English only, so German readers are sent to `/en`.
 */
export const SUPPORT_URL = 'https://support.mobeyond.eu';
